export default __webpack_public_path__ + "static/media/ticket.e9f2e70f.png";